import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'

import { I18nService } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-cookie-policy-page',
  templateUrl: './bmcore-cookie-policy-page.component.html',
  styleUrls: ['./bmcore-cookie-policy-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreCookiePolicyPageComponent implements OnInit {
  @Input() colorSettingsMode = false

  isEng: boolean

  constructor(
    private i18nService: I18nService,
    private titleService: Title
  ) {
    titleService.setTitle('Cookie policy | beatmakers.tv')
  }

  ngOnInit() {
    this.isEng = this.i18nService.isEng()
  }
}
